import { compose } from 'lodash/fp'
import React from 'react'
import { withTranslation } from 'react-i18next'
import DateFormatter, { IDayFormat } from './DateFormatter'
import withUpdate from './withUpdate'

const Component: React.ComponentType<IDayFormat> = compose(
  withUpdate,
  withTranslation(),
)(DateFormatter)

export default Component
